import { shortTextAndImage as schema } from 'web/schemas/contentful/_schema.mjs';
import { fakeProps } from 'web/schemas/contentfulTestData';

export const TestData = {
  header: 'Join as a Broker',
  bodyText:
    'As an Engel & Völkers Broker, you will benefit from the security offered by our internationally proven franchise business model, our pioneering system platform —– and unlimited sales opportunities.',
  imgFocalPoint: {
    metadata: {
      tags: [],
    },
    sys: {
      space: {
        sys: {
          type: 'Link',
          linkType: 'Space',
          id: '3g4b24b0tvoz',
        },
      },
      id: '1JS9pnyototkKnjUbdLANa',
      type: 'Entry',
      createdAt: '2023-04-05T18:26:50.464Z',
      updatedAt: '2023-04-05T18:47:09.523Z',
      environment: {
        sys: {
          id: 'master',
          type: 'Link',
          linkType: 'Environment',
        },
      },
      revision: 2,
      contentType: {
        sys: {
          type: 'Link',
          linkType: 'ContentType',
          id: 'imageWithFocalPoint',
        },
      },
      locale: 'en-US',
    },
    fields: {
      title: 'Test Focal Point Image',
      description: 'This is a test alt_text',
      image: {
        metadata: {
          tags: [],
        },
        sys: {
          space: {
            sys: {
              type: 'Link',
              linkType: 'Space',
              id: '3g4b24b0tvoz',
            },
          },
          id: '3mSo1mvBQW0eUIQ1pSBcaL',
          type: 'Asset',
          createdAt: '2023-03-31T19:57:05.021Z',
          updatedAt: '2023-03-31T19:57:05.021Z',
          environment: {
            sys: {
              id: 'master',
              type: 'Link',
              linkType: 'Environment',
            },
          },
          revision: 1,
          locale: 'en-US',
        },
        fields: {
          title: 'search-hero-bg',
          description: '',
          file: {
            url: '//images.ctfassets.net/3g4b24b0tvoz/3mSo1mvBQW0eUIQ1pSBcaL/71ca2c53ce98252e5c2ffb2fbee25a5c/search-hero-bg.png',
            details: {
              size: 1385758,
              image: {
                width: 1272,
                height: 595,
              },
            },
            fileName: 'search-hero-bg.png',
            contentType: 'image/png',
          },
        },
      },
      focalPoint: {
        focalPoint: {
          x: 1105,
          y: 308,
        },
      },
    },
  },
  ctaUrl: '#',
};

export default fakeProps(schema, TestData);
